export default __webpack_public_path__ + "static/media/154.159f9c69.jpg";